import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg viewBox="0 0 18 10" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M4.648.645l.704.71-3.14 3.11 14.79.035-.003 1-14.797-.035 3.153 3.183-.71.704L.293 4.958 4.648.646z" /></svg>;